module.exports = __webpack_public_path__ + "img/17.6.CODm.ea1b4b44.png";